module.exports = __webpack_public_path__ + "img/bb6db49d23402e5fbc6bed091a56ac82.png";